import { Component, OnInit } from '@angular/core'

import { LayoutState } from 'app/shared/layout/layout-state'
import { ResourceService } from 'app/shared/resources/resource.service'
import { TrackingService } from '../shared/tracking/tracking.service'
import { Router } from '@angular/router';
import { LoggingService } from 'app/shared/logging.service';
import { HybridService } from 'app/shared/hybrid/hybrid.service';

@Component({
    selector: 'sbw-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

    public header: string
    public body: string
    public backButtonVisible = false

    constructor(
        private layoutState: LayoutState,
        private resourceService: ResourceService,
        private trackingService: TrackingService,
        private router: Router,
        private logger: LoggingService,
        private hybridService: HybridService
    ) { }

    ngOnInit() {
        let correlation = window['sbCorrelationId']
        if (correlation) {
            this.router.navigate(['error/sbw'], { queryParams: { correlation } })
            return
        }
        this.logger.logError({ message: 'Not found page', path: window.location.pathname, query: window.location.search }, null)
        const locale = this.resourceService.getLocale()
        this.resourceService.loadResources('Default', locale, ['Common'])
        this.layoutState.setIsContentLoaded(true)
        this.backButtonVisible = true
        this.trackingService.trackNotFound()
    }

    public goBack() {
        this.hybridService.changeWindowLocation('/')
    }

}
